import { Navigate, Route, Routes, useNavigate } from "react-router-dom";
// import React, { Suspense, lazy } from "react";
import NotFound from "../404/NotFound.jsx";
import HomePage from "../HomePage/HomePage.jsx";
import AboutSection from "../AboutUsPage/AboutUsPage.jsx";
import BlogsPage from "../BlogsPage/BlogsPage.jsx";
import ContactUsPage from "../ContactUsPage/ContactUsPage.jsx";
import Education from "../Medical_Sector/Education.jsx";
import Banking from "../Medical_Sector/Banking.jsx";
import BookDemoPage from "../BookDemo/BookDemoPage.jsx";
import Travel from "../Medical_Sector/Travel.jsx";
import ECommerce from "../Medical_Sector/E_Commerce.jsx";
import Games from "../Medical_Sector/Games.jsx";
import Manufacture from "../Medical_Sector/Manufacture.jsx";
import Logistics from "../Medical_Sector/Logistic.jsx";
import GigWorkers from "../Medical_Sector/Gig_workers.jsx";
// import Industries from "../Medical_Sector/Industries.jsx";
import AllIndustries from "../Medical_Sector/AllIndustries.jsx";
import SingleBlogPage from "../SingleBlogPage/SingleBlogPage.jsx";
import ConsumerGoods from "../Medical_Sector/Consumer_Goods.jsx";
import MedicalSector from "../Medical_Sector/Medical_Sector.jsx";
import ItPage from "../ItPage/ItPage.jsx";
import Govt_API from "../Govt_API/Govt_API";
import Hr_Portal from "../Portal/HR_Portal";
import Self_Verification from "../Portal/Self_Verification.jsx";
import Offer_Portal from "../Portal/Offer_Portal.jsx";
import GR_Portal from "../Portal/GR_Portal.jsx";
import FMCG from "../Medical_Sector/FMCG.jsx";
import PageForCities from "../PagesForCities/PageForCities.jsx";
import useCheckForXSS from "../../Hooks/useCheckForXSS.js";
import SignUp from "../GetStartedForm/SignUp.jsx";
// import ChoosePackagePage from "../ChoosePackagePage/ChoosePackagePage.jsx";
import ProtectedRoute from "../../Components/ProtectedRoute/ProtectedRoute.jsx";
import CandidateDetailsForm from "../../Components/CandidateDetailsForm/CandidateDetailsForm.jsx";
import ContactWithSales from "../ContactWithSales/ContactWithSales.jsx";
import SuccessCard from "../../Components/CandidateDetailsForm/SuccessCard/SuccessCard.jsx";
import AppLayout from "../../Layouts/AppLayout.jsx";
import MainLayout from "../../Layouts/MainLayout.jsx";
import HR_Portal from "../Portal/HR_Portal";
import RefundPolicy from "../RefundPolicy/RefundPolicy.jsx";
import PrivacyPolicy from "../../Components/PrivacyPolicy/PrivacyPolicy.jsx";
import TermsOfService from "../TermsOfService/TermsOfService.jsx";
import IndustryLayout from "../../Layouts/IndustryLayout.jsx";
import BlogLayout from "../../Layouts/BlogLayout.jsx";
const AllRoutes = () => {
  const isSuspicious = useCheckForXSS();
  const navigate = useNavigate();

  if (isSuspicious) {
    // console.log('Suspicious', isSuspicious);
    navigate("/not-found", { replace: true });
  }
  return (
    <div>
      <Routes>
        <Route path="/" element={<AppLayout />}>
          {/* Main Layout routes */}
          <Route element={<MainLayout />}>
            <Route index element={<HomePage />} />
            <Route path="about-us" element={<AboutSection />} />
            <Route path="contact-us" element={<ContactWithSales />} />
            <Route path="product/hr-portal" element={<HR_Portal />} />
            <Route path="self-verification" element={<Self_Verification />} />
            <Route path="offer-portal" element={<Offer_Portal />} />
            <Route path="grievance-portal" element={<GR_Portal />} />
            <Route path="govt-api" element={<Govt_API />} />
            <Route path="sign-up" element={<SignUp />} />
            <Route path="privacy-policy" element={<PrivacyPolicy />} />
            <Route path="refund-policy" element={<RefundPolicy />} />
            <Route path="terms-of-service" element={<TermsOfService />} />

            {/* Protected nested routes */}
            <Route element={<ProtectedRoute />}>
              <Route
                path="candidate-details"
                element={<CandidateDetailsForm />}
              />
              <Route path="submission-success" element={<SuccessCard />} />
            </Route>
          </Route>

          {/* Industries Layout */}
          <Route path="industries" element={<IndustryLayout />}>
            <Route index element={<AllIndustries />} />
            <Route path="banking" element={<Banking />} />
            <Route path="healthcare" element={<MedicalSector />} />
            <Route path="online-gaming" element={<Games />} />
            <Route path="education" element={<Education />} />
            <Route path="manufacturing" element={<Manufacture />} />
            <Route path="it-ites" element={<ItPage />} />
            <Route path="gig-workers" element={<GigWorkers />} />
            <Route path="ecommerce" element={<ECommerce />} />
            <Route path="logistics" element={<Logistics />} />
            <Route path="consumer-goods" element={<ConsumerGoods />} />
            <Route path="fmcg-fmcd" element={<FMCG />} />
            <Route path="travel" element={<Travel />} />
          </Route>

          {/* Blog Layout */}
          <Route path="blogs" element={<BlogLayout />}>
            <Route index element={<BlogsPage />} />
            <Route path=":slug" element={<SingleBlogPage />} />
          </Route>

          {/* Redirect */}
          <Route
            path="hr_portal/*"
            element={<Navigate to="/product/hr-portal" replace />}
          />

          {/* Catch-all Not Found */}
          <Route path="*" element={<NotFound />} />
        </Route>
      </Routes>
    </div>
  );
};

export default AllRoutes;
